var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex align-center gc-4 py-2 px-3 rounded special--text bg-special cursor-pointer",
      attrs: { "data-qa": "lpu_loyalty_program_plate" },
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [
      _c("span", {
        staticClass:
          "ui-icon-four-pointed-star-fill ui-icon_type_40 bg-gray-0--text special flex-shrink-0",
      }),
      _vm._v(" "),
      _c("span", { staticClass: "text-body-1" }, [
        _vm._v(
          _vm._s(_setup.t("Программа лояльности клиники", _setup.options))
        ),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "ui-icon-arrow-right ml-auto" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }